import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Import utilities
import useToggle from 'components/utilities/hooks/toggle/useToggle';

const useMenuToggle = () => {
	const { pathname } = useLocation();
	const [isOpen, toggle] = useToggle();

	useEffect(() => {
		isOpen && toggle();
		// eslint-disable-next-line
	}, [pathname]);

	return { isOpen, toggle };
};

export default useMenuToggle;
